<template>
  <div>
    <v-overlay :value="loaders.loadingProducts" absolute opacity="0.1"></v-overlay>
    <v-card-title>
      <div class="title sidebar-headline font-weight-bold">{{ $t('searchableProducts.sidebar.categories') }}</div>
    </v-card-title>

    <div v-if="loaded" class="text-center mt-3 mb-3">
      <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
    </div>

    <v-list dense shaped v-else>

      <v-list-group
          v-for="category in rootCategories"
          :key="category.id"
          @click="toggleRootCategory(category); updateUrl(category);"
          :ref="category.permalink"
      >

        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="" class="text-uppercase">
              <a v-bind:href="'?categories=' + category.permalink" @click.prevent>
                {{ category.name }}
              </a>
            </v-list-item-title>
          </v-list-item-content>
          <v-icon>
            mdi-icon
          </v-icon>
        </template>

        <v-list class="pl-5" v-if="category.children.length > 0">
          <subcategories
              v-for="child in category.children"
              :key="child.id"
              :params="params"
              :subcategory="child"
              :categories="categories"
              :layout="layout"
          ></subcategories>
        </v-list>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import api from '../../../api/index';
import Subcategories from './categories/Subcategories';

export default {
  components: {Subcategories},
  props: ['params', 'layout', 'loaders'],
  data() {
    return {
      categories: [],
      lastCategory: {},
      loadingCategories: true,
    };
  },
  created() {
    this.setSearchKeywordFromUrl();
    this.fetchCategories();
  },
  updated() {
    if (this.categories && this.params.categories.length === 0 && !this.params.setCategoriesFromUrl) {
      this.setCategoriesFromUrl(this.categories);
    }
  },
  computed: {
    rootCategories() {
      return this.categories.filter(category => {
        return category.depth === 0;
      });
    },
    loaded() {
      return this.loadingCategories;
    },
  },
  methods: {
    fetchCategories() {
      this.loadingCategories = true;

      api.get(`/api/v2/storefront/taxons/categories`).then(res => {
        const {data} = res;
        this.categories = data;
        this.loadingCategories = false;
      });
    },
    toggleRootCategory(category) {
      if (this.lastCategory.id) {
        this.deactivateChildren(this.lastCategory);
      }

      this.lastCategory = category;

      let includeRootCategory = [];
      if (this.params.categories) {
        includeRootCategory = this.params.categories.filter(rootCategory => {
          return rootCategory.depth === 0 && rootCategory === category;
        });
      }

      this.params.categories = [];

      if (includeRootCategory.length === 0) {
        this.params.categories.push(category);
      } else {
        this.removeCategoryFromUrl();
      }
    },

    removeCategoryFromUrl() {
      setTimeout(() => {
        const url = new URL(location.href);
        url.searchParams.delete('categories');
        history.pushState(null, '', url.toString());
      }, 100);
    },

    updateUrl(category) {
      const url = new URL(location.href);
      url.searchParams.set('categories', category.permalink);
      history.pushState(null, '', url.toString().replace('%2F', '/'));
    },

    deactivateCategory(category) {
      if (category.permalink) {
        this.$refs[category.permalink][0].isActive = false;
        this.removeCategoryFromUrl();
      }
    },
    deactivateChildren(category) {
      if (category.permalink && this.$refs[category.permalink][0].$children.length > 1) {
        this.$refs[category.permalink][0].$children[1].$children.forEach(
            child => child.$children[0].isActive = false);
      }
    },
    setCategoriesFromUrl(data) {
      const searchParams = new URLSearchParams(location.search);
      const categories = searchParams.get('categories');
      if (Boolean(categories)) {
        this.layout.categoriesFromUrl = categories.split('/');

        if (this.layout.categoriesFromUrl[0]) {
          const category = data.filter(category => {
            if (!category.name) {
              return false;
            }
            if (!category.permalink) {
              console.warn('Missing permalink for : ' + category.name)
            }
            return category.permalink && category.permalink.toLowerCase() === this.layout.categoriesFromUrl[0].toLowerCase();

          })[0];
          if (typeof category !== 'undefined') {
            this.toggleRootCategory(category);
          } else {
            this.removeCategoryFromUrl();
          }

          if (category && category.permalink) {
            this.$refs[category.permalink][0].isActive = true;
          }

          if (this.layout.categoriesFromUrl.length === 1) {
            this.params.setCategoriesFromUrl = true;
          }
        }
      }
    },
    setSearchKeywordFromUrl() {
      const searchParams = new URLSearchParams(location.search);
      this.params.search = searchParams.has('search') ? searchParams.get('search') : '';
    }
  },
  watch: {
    'params.categories': function (oldValue, newValue) {
      if (oldValue.length === 0 && newValue.length === 0 && this.lastCategory) {
        this.deactivateCategory(this.lastCategory);
      }
      if (oldValue.length > 0) {
        if (oldValue[0] && oldValue[0].depth !== 0 && this.lastCategory) {
          this.params.categories = [];
          this.deactivateCategory(this.lastCategory);
        }
      }
    },
  },
};
</script>
